import * as React from 'react';
import {connect} from 'react-redux';
import EventHandlingModal, {EventHandlingModalProps} from './EventHandlingModal';
import ReduxState from '../../types/ReduxState';
import {TscButtonTypes} from '@techsmith/tsc-cloud-style-guide';

const mapStateToProps = (state: ReduxState, ownProps: EventHandlingModalContainerProps): EventHandlingModalProps => {
   return {
      visible: ownProps.visible,
      title: ownProps.title,
      closeContent: ownProps.closeContent,
      confirmContent: ownProps.confirmContent,
      confirmButtonType: ownProps.confirmButtonType,
      dismissContent: ownProps.dismissContent,
      children: ownProps.children || {},
      defaultOnClose: ownProps.defaultOnClose,
      modalEventHandlers: state.modalEventHandlers || {},
      testId: ownProps.testId || ''
   };
};

export default connect(mapStateToProps, {})(EventHandlingModal);

interface EventHandlingModalContainerProps {
   visible: boolean;
   title: string;
   closeContent: string;
   confirmContent: string;
   confirmButtonType: TscButtonTypes;
   dismissContent: string;
   testId?: string;
   children?: React.ReactNode;
   defaultOnClose(): void;
}
